export default function goToRedirect(url, queryStringName, queryStringValue) {
  return (async () => {
    window.location.assign(`${url}?${queryStringName}=${queryStringValue}`);
  })();
}
